export function StarRating({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      width="90"
      height="17"
      viewBox="0 0 90 17"
      fill="none"
      className={`shrink-0 ${className ?? ""}`}
    >
      <path
        d="M7.61 0L9.32 5.77H14.85L10.37 9.34L12.08 15.11L7.61 11.55L3.14 15.11L4.84 9.34L0.37 5.77H5.9L7.61 0Z"
        fill="white"
      />
      <path
        d="M26.3 0L28.01 5.77H33.54L29.07 9.34L30.78 15.11L26.3 11.55L21.83 15.11L23.54 9.34L19.07 5.77H24.6L26.3 0Z"
        fill="white"
      />
      <path
        d="M45 0L46.71 5.77H52.24L47.76 9.34L49.47 15.11L45 11.55L40.53 15.11L42.24 9.34L37.76 5.77H43.29L45 0Z"
        fill="white"
      />
      <path
        d="M63.7 0L65.4 5.77H70.93L66.46 9.34L68.17 15.11L63.7 11.55L59.22 15.11L60.93 9.34L56.46 5.77H61.99L63.7 0Z"
        fill="white"
      />
      <mask
        id="hero-video-star-mask"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="75"
        y="0"
        width="15"
        height="16"
      >
        <path
          d="M82.39 0L84.1 5.77H89.63L85.16 9.34L86.86 15.11L82.39 11.55L77.92 15.11L79.63 9.34L75.16 5.77H80.68L82.39 0Z"
          fill="black"
        />
      </mask>
      <g mask="url(#hero-video-star-mask)">
        <rect x="73.13" y="-3.21" width="16.87" height="20.89" fill="white" />
      </g>
    </svg>
  );
}
